export default __webpack_public_path__ + "static/media/radio_logo.86863a22.png";